module.exports = __webpack_public_path__ + "img/gift.e1647078.png";